import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { dddLabel, dddUF } from "@/lib/ddd";

export const DddSummary = ({ api, active, onPick, tick }) => {
  const [data, setData] = useState(null);
  const [byUF, setByUF] = useState(false);
  useEffect(() => {
    api.get("/admin/participants/summary").then((r) => setData(r.data)).catch(() => {});
  }, [api, tick]);
  if (!data) return null;
  const groups = byUF
    ? Object.entries(data.by_ddd.reduce((acc, r) => { const uf = dddUF(r.ddd) || "?"; acc[uf] = (acc[uf] || 0) + r.count; return acc; }, {}))
        .sort((a, b) => b[1] - a[1]).map(([uf, count]) => ({ key: `uf:${uf}`, title: uf, sub: "", count }))
    : data.by_ddd.map((r) => ({ key: r.ddd, title: `(${r.ddd})`, sub: dddLabel(r.ddd), count: r.count }));
  const chip = (on) => `flex shrink-0 items-center gap-2 rounded-full border px-3 py-1.5 text-sm transition-colors ${on ? "border-zap-deep bg-zap-deep text-white" : "border-zap-line bg-white hover:bg-zap-mist"}`;
  return (
    <section data-testid="participants-summary" className="space-y-3 border-b border-zap-line bg-zap-mist/50 px-5 py-4 md:px-8">
      <div className="flex flex-wrap items-center gap-3">
        <p className="flex items-center gap-2 font-display text-2xl font-semibold text-zap-deep">
          <Users className="h-6 w-6" /><span data-testid="participants-total">{data.total}</span>
          <span className="text-base font-normal text-zap-ink/70">{data.total === 1 ? "pessoa cadastrada" : "pessoas cadastradas"}</span>
        </p>
        <span className="flex items-center gap-1.5 text-xs text-muted-foreground"><span className="h-2 w-2 animate-pulse rounded-full bg-emerald-500" />atualiza sozinho</span>
        <div className="ml-auto flex rounded-full border border-zap-line bg-white p-0.5 text-sm">
          <button type="button" data-testid="summary-by-ddd" onClick={() => setByUF(false)} className={`rounded-full px-3 py-1 ${!byUF ? "bg-zap-deep text-white" : ""}`}>Por DDD</button>
          <button type="button" data-testid="summary-by-uf" onClick={() => setByUF(true)} className={`rounded-full px-3 py-1 ${byUF ? "bg-zap-deep text-white" : ""}`}>Por estado</button>
        </div>
      </div>
      <div className="scroll-thin flex gap-2 overflow-x-auto pb-1">
        <button type="button" data-testid="ddd-chip-all" onClick={() => onPick(null)} className={chip(!active)}>Todos <b>{data.total}</b></button>
        {groups.map((g) => (
          <button type="button" key={g.key} data-testid={`ddd-chip-${g.key}`} onClick={() => onPick(active === g.key ? null : g.key)} className={chip(active === g.key)}>
            <b>{g.title}</b>{g.sub && <span className={active === g.key ? "text-white/80" : "text-muted-foreground"}>{g.sub}</span>}
            <span className={`rounded-full px-2 text-xs font-bold ${active === g.key ? "bg-white/20" : "bg-zap-mist text-zap-deep"}`}>{g.count}</span>
          </button>
        ))}
      </div>
    </section>
  );
};
